import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // isLoggedIn: false,
  // data: "",
  // token: null,
  emailAddress: "",
  userProfileData: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setEmailAddress: (state, action) => {
      state.emailAddress = action.payload;
    },
  },
});

export const { setEmailAddress } = userSlice.actions;

export default userSlice.reducer;
